export const MAPYBOX_ITEM_UPDATE_EVENT_NAME = "mapybox-item-update";
export const MAPYBOX_TRACK_LINK_EVENT_NAME = "mapybox-track-link";
